import SubmenuObserver from '../submenu-observer';
import { restoreFocusForSubmenu, disableFocusForSubmenu } from '../submenu-tools';


const $ = jQuery;

/**
 * please see CMS-4980 for details on this script
 */
export default function () {
	// Loading on windows.onload since custom javascript could
	// add its code, after DomReady event but before window.load event
	$(window).on('load', () => {
		// Wait for 2 seconds, since custom JS can take up to 1 second
		setTimeout(() => {
			$('.menu-item-has-children')
				.each(function () {
					// Disclosure button can belong to custom JS (fl-toggle-icon or toggle-menu clases)
					// or to the platform (button element)
					const disclosureButtons = $(this)
						.children('a.fl-toggle-icon,a.toggle-menu,button');
					disclosureButtons.attr('aria-expanded', false);
					// if we inside mobile menu with custom toggle icon next item will be
					// a disclosure button we need to disable default disclosure button
					if (disclosureButtons.length >= 2) {
						disclosureButtons.filter('button').hide();
					}
					// Provide aria-label for sites with customized disclosure button
					disclosureButtons.filter('a.toggle-menu,a.fl-toggle-icon').each(function () {
						let label = $(this).prev().text();
						label += ' Submenu';
						$(this).attr('aria-label', label);
					});

					const observer = new SubmenuObserver(this);
					observer.onShow(() => {
						disclosureButtons.attr('aria-expanded', true);
						restoreFocusForSubmenu(this);
					});
					observer.onHide(() => {
						disclosureButtons.attr('aria-expanded', false);
						disableFocusForSubmenu(this);
					});
					observer.connect();
				});

			$('.fl-menu-toggle-only').each(function () {
				if (!this.hasAttribute('href')) {
					$(this).attr('href', '#');
				}
			});
			// Because of custom JS some sites having issues with opening
			// burger menu using the keyboard
			$('.mobile_nav').off('keydown');
			$('.mobile_menu_bar').off('keyup');
			$('.mobile_menu_bar').on('keydown', function (event) {
				if (event.keyCode === 13 || event.keyCode === 32) {
					event.preventDefault();
					$(this).click();
				}
			});
		}, 2000);
	});
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/controllers/provide-aria-expanded-in-submenus.js